import { IAppMessageMetadata } from "common/api/appMessage.service";
import { IAppMessageRecipientData } from "common/records/AppMessage";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_APP_MESSAGE = "@appMessage/RECEIVE_APP_MESSAGE";
export const RECEIVE_APP_MESSAGES = "@appMessage/RECEIVE_APP_MESSAGES";
export const ADD_APP_MESSAGE = "@appMessage/ADD_APP_MESSAGE";
export const UPDATE_APP_MESSAGE = "@appMessage/UPDATE_APP_MESSAGE";
export const SET_LOAD_FAILED = "@appMessage/SET_LOAD_FAILED";
export const CLEAR_APP_MESSAGES = "@appMessage/CLEAR_APP_MESSAGES";

export const AppMessageActions = {
  receiveAppMessage: (message: IAppMessageRecipientData) => createAction(RECEIVE_APP_MESSAGE, { message }),
  receiveAppMessages: (messages: IAppMessageRecipientData[], metadata: IAppMessageMetadata) =>
    createAction(RECEIVE_APP_MESSAGES, { messages, metadata }),
  addAppMessage: (message: IAppMessageRecipientData, metadata: IAppMessageMetadata) =>
    createAction(ADD_APP_MESSAGE, { message, metadata }),
  updateAppMessage: (message: IAppMessageRecipientData, metadata: IAppMessageMetadata) =>
    createAction(UPDATE_APP_MESSAGE, { message, metadata }),
  setLoadFailed: (failed: boolean) => createAction(SET_LOAD_FAILED, { failed }),
  clearAppMessages: () => createAction(CLEAR_APP_MESSAGES),
};

export type AppMessageActions = ActionsUnion<typeof AppMessageActions>;
